import { gql, useLazyQuery, useQuery } from "@apollo/client";
import {
  StatisticsSearchRoutePairListByFilterOptions,
  UseRoutePairListQuery,
  UseRoutePairListQueryVariables,
} from "@/gql/graphql";

const query = gql`
  fragment NumberVolumeStatisticsRoutePair on NumberVolumeStatisticsItem {
    percentageOfAccount
    percentageOfVolume
  }
  fragment RoutePairListItems on StatisticsByRoutePairListItem {
    routePair {
      id
      code
      description
    }
    negotiationStatusStatistics {
      accounts
      statistics {
        negotiationStatus {
          id
          name
        }
        numberVolumeStatistics {
          ...NumberVolumeStatisticsRoutePair
        }
      }
    }
  }
  query UseRoutePairList(
    $filterOptions: StatisticsSearchRoutePairListByFilterOptions!
  ) {
    statistics {
      routePairList {
        byFilter(filterOptions: $filterOptions) {
          items {
            ...RoutePairListItems
          }
        }
      }
    }
  }
`;

export const useRoutePairListQuery = () => {
  const [fetchRoutePairList, { error, loading, data }] = useLazyQuery<
    UseRoutePairListQuery,
    UseRoutePairListQueryVariables
  >(query, {
    fetchPolicy: "network-only",
  });

  return {
    error,
    loading,
    routePairItems: data?.statistics.routePairList.byFilter?.items,
    fetchRoutePairList,
  };
};
